// i18n keys of the multi-tenant work package "dialcode" (en / zh / th). ⛔ Fill all three: an empty th value falls back to English.
export const en: Record<string, string> = {};
export const zh: Record<string, string> = {};
export const th: Record<string, string> = {};
